import React from 'react';
import PropTypes from 'prop-types';

import Recommend from './Recommend';
import Button from 'widgets/Button';

const UserControls = ({ review, sku, deleteReview, setHelpfulness, customerReviewId, isLoggedIn, router }) => (
  <div className="bop-reviews__controls">
    <Button
      secondary
      size="small"
      onClick={() => deleteReview(sku, review.reviewId)}
    >
      Remove
    </Button>
    <Recommend
      setHelpfulness={setHelpfulness}
      sku={sku}
      review={review}
      customerReviewId={customerReviewId}
      isLoggedIn={isLoggedIn}
      router={router}
    />
  </div>
);

UserControls.propTypes = {
  review: PropTypes.object.isRequired,
  deleteReview: PropTypes.func.isRequired,
  setHelpfulness: PropTypes.func.isRequired,
  sku: PropTypes.string.isRequired,
  customerReviewId: PropTypes.number,
  isLoggedIn: PropTypes.bool.isRequired,
  router: PropTypes.object.isRequired,
};

export default UserControls;
